import { fillLevelSensorsContainersOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("fill-level-sensors-containers"),
  endpoint: "fill-level-sensors/containers",
  operations: fillLevelSensorsContainersOps,
  roleView: [ROLE.CONTAINER_VIEW, ROLE.CONTAINER_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN],
  singularName: (t) => t("Container"),
  name: (t) => t("Fill Containers"),
  initialFilter: {
    status: "active",
  },
  syncCustomerFilter: true,
  dependencies: ["region-code"],
});

export default conf;
